import { render } from "./Next_js.vue?vue&type=template&id=c1d2e6aa"
import script from "./Next_js.vue?vue&type=script&lang=js"
export * from "./Next_js.vue?vue&type=script&lang=js"

import "./Next_js.vue?vue&type=style&index=0&id=c1d2e6aa&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__